import React from "react"
import { RouteObject } from "react-router-dom"
import NewPropertyComponent from "../component/new-property-component"
import PropertyPage from "../page/property.page"
import AuthGuard from "../../../shared/auth/component/auth"
export const PropertyRoute: RouteObject = {
  path: "/property",
  element: (
    <AuthGuard role={["super_admin"]} permission={["manage-properties", "view-properties"]}>
      <PropertyPage />
    </AuthGuard>
  ),
  children: [
    {
      path: "detail/:type/:id",
      element: <NewPropertyComponent editMode="detail" />,
    },
    { path: ":id", element: <NewPropertyComponent editMode="new" /> },
  ],
}
